// DS: C25L
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import UserName from '../User/BasicUserName';
import StreamedList from '../StreamedList';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import s from './Who.scss';
const biSectionMap = {
    comment: 'comments_pop_up',
    favourite: 'fave_pop_up'
};
const NUM_USERS_SHOWN = 4;
const Who = ({ streamId, users, total, isFetching, isInitialized, initialize, userListType, deviation, deviation: { deviationId }, dataHook, showFavouritedByModal })=>{
    const { t } = useTranslation();
    const [isOpen, setOpen] = useState(false);
    // init stream if needed
    useEffect(()=>{
        if (!isInitialized) {
            initialize(streamId, deviationId, userListType);
        }
    }, [
        streamId,
        deviationId,
        userListType,
        isInitialized,
        initialize
    ]);
    const totalToShow = Math.max(total, users.length);
    const hasOverflow = totalToShow > NUM_USERS_SHOWN;
    const isEmpty = totalToShow === 0;
    const isFetchingInitial = isFetching && users.length === 0;
    const visibleSlice = !hasOverflow || isOpen ? users : users.slice(0, NUM_USERS_SHOWN);
    const remainingCount = hasOverflow && !isOpen ? totalToShow - visibleSlice.length : 0;
    const userList = visibleSlice.map((user)=>/*#__PURE__*/ React.createElement(UserLink, {
            user: user,
            className: s['user'],
            key: user.userId
        }, /*#__PURE__*/ React.createElement("span", {
            className: s['user-avatar']
        }, /*#__PURE__*/ React.createElement(UserAvatar, {
            size: 16,
            user: user,
            withLink: false
        })), /*#__PURE__*/ React.createElement("span", {
            className: s['username']
        }, /*#__PURE__*/ React.createElement(UserName, {
            user: user
        }))));
    const onClickMore = ()=>{
        if (userListType === 'favourite') {
            showFavouritedByModal(deviation);
        } else {
            setOpen(true);
        }
    };
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionname: biSectionMap[userListType]
        }
    }, /*#__PURE__*/ React.createElement("div", {
        "data-hook": dataHook,
        className: classnames('no-theme-skin', s['root'], hasOverflow && s['overflow'], isOpen && s['open'], (isEmpty || !isInitialized || isFetchingInitial) && s['empty'])
    }, isFetchingInitial || !isInitialized ? /*#__PURE__*/ React.createElement("div", null, t('who.fetching')) : isEmpty ? /*#__PURE__*/ React.createElement("div", null, t(`who.empty.var.${userListType}`)) : isOpen ? /*#__PURE__*/ React.createElement(StreamedList, {
        className: s['list'],
        wrapperClassName: s['scrollable'],
        bottomedClassName: s['bottomed'],
        scrolledClassName: s['scrolled'],
        streamId: streamId
    }, userList) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['list']
    }, userList), hasOverflow && /*#__PURE__*/ React.createElement(BiButton, {
        className: s['more'],
        onClick: onClickMore,
        biData: BiData({
            evid: 2,
            click_info: 'deviation.who.more',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        })
    }, t('who.more', {
        count: remainingCount
    })))));
};
Who.displayName = 'Who';
export default Who;
